import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import React, { useState } from 'react'
import styles from "./styles";
import clsx from 'clsx';
import CancelIcon from '@material-ui/icons/Cancel';
import PropTypes from "prop-types"
import logoIcon from "./icon-upload.png"

function FileUploadImage(props) {
  const {
    id,
    name,
    handleChange,
    value,
    uploadImageClass,
    uploadButtonClass,
    variant,
    onRemoveFile,
    helperText,
  } = props

  const [isFileDirty, setIsFileDirty] = useState(false);
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const buttonImagePreviewContainer = clsx(isFileDirty ? classes.buttonImage :
    classes.buttonImagePreview);

  return (
    <div className={variant === "image-file" ? uploadImageClass : uploadButtonClass}>
      <input
        type="file"
        id={id}
        data-apim-test={id}
        className={classes.hideInput}
        onChange={(e) => {
          handleChange(e.target.files[0])
          if (e.target.files[0]) {
            setIsFileDirty(true);
          }
        }}
      />
      {
        variant === "image-file" ?
          <div className={classes.uploadPreviewContainer}>
            {
              isFileDirty &&
              <div
                id='upload-image-file-cancel-button'
                data-apim-test='upload-image-file-cancel-button'
                onClick={() => {
                  setIsFileDirty(false)
                  onRemoveFile()
                }}
                className={classes.cancelIcon}
              >
                <CancelIcon />
              </div>
            }
            <label htmlFor={id}>
              {value ? (
                <Box>
                  <div className={classes.imagePreviewContainer}>
                  <img className={classes.imagePreview} src={value} alt="file-image-preview" />
                  </div>
                  {helperText &&
                    <Typography className={classes.errorMessage}>{helperText}</Typography>
                  }
                </Box>
              ) : (
                <div id={id} className={classes.uploadImageContainer}>
                  <div className={classes.iconsContainer}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                      <path d="M0 7.50012L8 0.00012207L15.5 7.50012H11V14.5001H4.5V7.50012H0Z" fill="white" />
                    </svg>
                    <img src={logoIcon} className={classes.logoIcon} />
                  </div>
                  {
                    <Typography className={classes.name}>{name}</Typography>
                  }
                </div>
              )}
            </label>
          </div>
          :
          <div className={classes.uploadButtonContainer}>
            <label htmlFor={id}>
              <Button
                id={id}
                className={classes.uploadFileButton}
                variant="contained"
                color='secondary'
                component="span"
                startIcon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path d="M4 13.4448L12.2581 5.5L20 13.4448H15.3548V19.5H8.64516V13.4448H4Z" fill="white" />
                  </svg>
                }
              >
                {name}
              </Button>
              {helperText && <Typography className={classes.errorMessage}>{helperText}</Typography>}
            </label>
            {
              value &&
              <div className={classes.uploadPreviewContainer}>
                <img className={buttonImagePreviewContainer} src={value} alt="file-button-preview" />
                {
                  isFileDirty &&
                  <div
                    id='upload-button-file-cancel-button'
                    data-apim-test='upload-button-file-cancel-button'
                    onClick={() => {
                      setIsFileDirty(false);
                      onRemoveFile()
                    }}
                    className={classes.cancelIcon}
                  >
                    <CancelIcon />
                  </div>
                }
              </div>
            }
          </div>
      }
    </div>
  )
}

FileUploadImage.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  handleChange: PropTypes.func,
  value: PropTypes.string,
  uploadImageClass: PropTypes.string,
  uploadButtonClass: PropTypes.string,
  variant: PropTypes.string,
  onRemoveFile: PropTypes.func,
  helperText: PropTypes.string,
}

export default FileUploadImage;
